import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const NAME_FORMAT = /^[A-Za-z_][A-Za-z0-9_]*$/;

export function nameFormatValidator(validatePristine: boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!validatePristine && control.pristine) return null;

        const value = control.value;
        if (value === null || value === undefined || value === '') return null;

        return typeof value === 'string' && NAME_FORMAT.test(value) ? null : { nameFormat: true };
    };
}
